import React from 'react';
import { FlaskConicalIcon, HeartIcon, ShieldIcon } from 'lucide-react';
const ResearchSection: React.FC = () => {
  return <section className="w-full py-16 px-4 bg-gray-900" data-id="element-266">
      <div className="max-w-5xl mx-auto" data-id="element-267">
        <div className="text-center mb-12" data-id="element-268">
          <h2 className="text-3xl font-bold mb-4" data-id="element-269">
            FÖRSTÅ NYCKELFAKTORERNA FÖR SEXUELL HÄLSA
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto" data-id="element-270">
            Upptäck de viktigaste faktorerna som påverkar din sexuella
            prestationsförmåga och hälsa.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-271">
          <div className="p-6 bg-[#0A1020] rounded-lg" data-id="element-272">
            <div className="mb-4 text-[#0EB7FF]" data-id="element-273">
              <FlaskConicalIcon className="w-8 h-8" data-id="element-274" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-275">Blodcirkulation</h3>
            <p className="text-gray-300 text-sm" data-id="element-276">
              Inuti penis hittar du corpora cavernosa som är som kammare som
              fylls med blod. God blodcirkulation är avgörande för att få
              kraftiga och långvariga erektioner. Livsstilsfaktorer som kost och
              motion påverkar detta direkt.
            </p>
          </div>
          <div className="p-6 bg-[#0A1020] rounded-lg" data-id="element-277">
            <div className="mb-4 text-[#0EB7FF]" data-id="element-278">
              <HeartIcon className="w-8 h-8" data-id="element-279" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-280">Hormonbalans</h3>
            <p className="text-gray-300 text-sm" data-id="element-281">
              Testosteron är det hormon som är ansvarigt för den manliga
              sexdriften och har stark påverkan på erektionskvalitet och
              orgasmintensitet. Stress, sömn och kost påverkar alla dina
              hormonnivåer.
            </p>
            <div className="mt-4 p-3 bg-gray-800 rounded text-xs text-gray-300 border-l-2 border-[#0EB7FF]" data-id="element-282">
              Viktigt: Efter 30 års ålder börjar testosteronnivåerna naturligt
              sjunka med cirka 1% per år. Detta kan påverka din sexuella
              prestationsförmåga över tid.
            </div>
          </div>
          <div className="p-6 bg-[#0A1020] rounded-lg" data-id="element-283">
            <div className="mb-4 text-[#0EB7FF]" data-id="element-284">
              <ShieldIcon className="w-8 h-8" data-id="element-285" />
            </div>
            <h3 className="text-xl font-semibold mb-2" data-id="element-286">
              Naturliga näringsämnen
            </h3>
            <p className="text-gray-300 text-sm" data-id="element-287">
              Vissa naturliga ingredienser har använts i tusentals år för att
              förbättra manlig sexuell hälsa. Rätt näringsämnen kan hjälpa till
              att optimera blodcirkulation, hormonbalans och energinivåer på ett
              naturligt sätt.
            </p>
            <p className="mt-2 text-xs text-gray-400" data-id="element-288">
              En balanserad kost rik på antioxidanter, zink, D-vitamin och
              omega-3 kan bidra till bättre sexuell hälsa.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ResearchSection;